// Created by jarongallo at 3/30/21
import React, { useEffect, useState } from 'react';
import './styles';
import UIHover from '../../../../../components/UI/UIHover/UIHover';
import { PlusIcon } from '../../../../../assets/icons';
import Promo from '../../../../../components/UI/UIPromo/UIPromo';
import UIModal from '../../../../../components/UI/UIModal';
import CreatePromoModal from '../../../../../components/modals/CreatePromoModal';
import { useLazyQuery } from '@apollo/react-hooks';
import { GET_TECHNICIAN_PROMOS } from './queries';
import Queries from '../../../../../utils/API/Queries';
import { toast } from 'react-toastify';
import { useApolloClient } from '@apollo/react-hooks';

export default function IndividualTechnicianPromos({ technicianId, ...rest }: IndividualTechnicianPromotionsProps) {
	const [showCreatePromotionModal, setShowCreatePromotionModal] = useState(false);
	const [inviteCode] = useState();
	const [promos, setPromos] = useState<PromoType[]>();

	const client = useApolloClient();

	const [getTechnicianPromos, { data: promosData }] = useLazyQuery(GET_TECHNICIAN_PROMOS, {
		variables: { user: technicianId }
	});

	useEffect(() => {
		(async () => {
			await getTechnicianPromos();
		})();
	}, []);

	useEffect(() => {
		(() => {
			if (promosData) {
				const fetchedPromos: PromoType[] = promosData['promos'];
				setPromos(fetchedPromos);
			}
		})();
	}, [promosData]);

	if (!promos) return null;

	const deletePromo = async (promo) => {
		const response = await client
			.mutate({
				mutation: Queries.DELETE_PROMO,
				variables: { promoId: promo.id }
			})
			.catch((error) => toast.error('Error removing trainee! ' + error.message));
		const { deletePromo } = response['data'];
		if (deletePromo) {
			await getTechnicianPromos();
			toast.success('Successfully deleted promo!');
		}
	};

	const renderCreatePromotionModal = () => {
		const hideModal = () => setShowCreatePromotionModal(false);

		const onCreatePromo = async () => {
			await getTechnicianPromos();
			hideModal();
		};

		return (
			<UIModal condition={showCreatePromotionModal}>
				<CreatePromoModal userId={technicianId} hideModal={hideModal} inviteCode={inviteCode} onFinish={onCreatePromo} />
			</UIModal>
		);
	};

	return (
		<div className='individualTechnicianPromos'>
			<div className='individualTechnicianPromos__header'>
				<p className='page-title'>PROMOS</p>
				<UIHover text={'add a promo'}>
					<img className='individualTechnicianPromos__header--icon' src={PlusIcon.white} alt={'add'} onClick={() => setShowCreatePromotionModal(true)} />
				</UIHover>
			</div>
			<div className='pl-separator' />
			<div className='promo-container'>
				{promos ? (
					promos.filter((promo) => promo.uses < promo.maxUses).length > 0 ? (
						promos
							.filter((promo) => promo.uses < promo.maxUses)
							.map((promo) => {
								return <Promo {...rest} key={promo.id} promo={promo} removePromo={deletePromo} />;
							})
					) : (
						<p style={{ marginTop: 8 }}>There are no active photographer promotions...</p>
					)
				) : undefined}
			</div>
			{renderCreatePromotionModal()}
		</div>
	);
}
